module.exports = __webpack_public_path__ + "img/MX-D128110A-BS-HQ.cfe5b228.png";